{
  "name": "webflow-js-controller-funnel",
  "version": "0.14.29",
  "private": true,
  "license": "UNLICENSED",
  "author": "Adtractive",
  "source": "src/index.ts",
  "scripts": {
    "build": "parcel build src/index.ts",
    "check": "tsc --noEmit",
    "ci": "npm run build && npm run test && npm run lint && npm run check",
    "deploy": "../scripts/deployFunnel.sh",
    "test": "jest"
  },
  "browserslist": "> 0.3%, last 7 major versions",
  "dependencies": {
    "@stripe/stripe-js": "^4.3.0",
    "axios": "^1.7.3",
    "bowser": "^2.11.0",
    "braintree-web": "^3.105.0",
    "card-validator": "^10.0.0",
    "country-state-city": "^3.2.1",
    "intl-tel-input": "^19.2.20",
    "localforage": "^1.10.0",
    "superstruct": "^2.0.2",
    "ua-parser-js": "^1.0.38",
    "uuid": "^10.0.0"
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@babel/plugin-proposal-optional-chaining": "^7.21.0",
    "@babel/plugin-proposal-private-methods": "^7.18.6",
    "@babel/preset-env": "^7.25.3",
    "@parcel/compressor-brotli": "^2.12.0",
    "@parcel/compressor-gzip": "^2.12.0",
    "@parcel/config-default": "^2.12.0",
    "@parcel/packager-ts": "2.12.0",
    "@parcel/transformer-typescript-tsc": "^2.12.0",
    "@parcel/transformer-typescript-types": "2.12.0",
    "@parcel/validator-typescript": "^2.12.0",
    "@sentry/browser": "^8.22.0",
    "@sentry/tracing": "^7.114.0",
    "@types/braintree-web": "^3.96.12",
    "@types/google.maps": "^3.55.12",
    "@types/googlepay": "^0.7.6",
    "@types/intl-tel-input": "^18.1.4",
    "@types/jest": "^29.5.12",
    "@types/jquery": "^3.5.30",
    "@types/node": "^22.1.0",
    "@types/ua-parser-js": "^0.7.39",
    "@types/uuid": "^10.0.0",
    "buffer": "^6.0.3",
    "dotenv": "^16.4.5",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "parcel": "^2.12.0",
    "process": "^0.11.10",
    "ts-jest": "^29.2.4",
    "ts-node": "^10.9.2",
    "typescript": "^5.5.4"
  }
}
